import { authRequest } from './utils';

/**
 * fetchUsers :: _ -> Promise Error Object
 */
export const fetchUsers = () =>
  authRequest({
    method: 'GET',
    url: '/users',
  })
    .then(({ data }) => data);

/**
 * deleteUserById :: ID -> Promise Error
 */
export const deleteUserById = _id =>
  authRequest({
    method: 'DELETE',
    url: `/users/archive-user/${_id}`,
  })
    .then(({ data: { user } }) => user);

/**
 * changeUserRole :: (ID, Object) -> Promise Error
 */
export const changeUserRole = (_id, data) =>
  authRequest({
    method: 'PATCH',
    url: `/users/change-role/${_id}`,
    data,
  })
    .then(({ data: { user } }) => user);

/**
 * restoreUser :: ID -> Promise Error
 */
export const restoreUser = _id =>
  authRequest({
    method: 'POST',
    url: `/users/restore-user/${_id}`,
  })
    .then(({ data: { user } }) => user);



// WEBPACK FOOTER //
// ./src/api/apiko-api/users.js